
const endpoints = {
  "tokens": "/tokens",
  "balances": "/balances",
  "quote": '/quote',
  "route": "/route",
  "chart": "/chart",
  "token": "/token"
};

export default endpoints;